import * as CubeTree from '../cubeTree/index';

// 更新所有货架的class标记
function updateAllShelfsClass(): void {
    let shels: CubeId[] = CubeTree.getCubeByType('shelf');
    let freezers: CubeId[] = CubeTree.getCubeByType('freezer');
    let targets: CubeId[] = shels.concat(freezers);

    targets.forEach((cubeId: CubeId): void => {
        let cube: CubeNode = CubeTree.findByCubeId(cubeId);

        cube.update({
            onlyUpdateClass: true
        });
    });
}

export {
    updateAllShelfsClass
};
